import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { PiCalendarBlank } from "react-icons/pi";
import "./ai-settings.css";

const OPTIONS = ["Immediately", "Test", "Schedule for later"];

const toDateValue = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const getMinDate = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  d.setHours(0, 0, 0, 0);
  return d;
};

const DateInput = React.forwardRef(({ value, onClick, onChange, onFocus, disabled }, ref) => (
  <button
    type="button"
    className="ais-datepicker-trigger"
    onClick={disabled ? undefined : onClick}
    onFocus={disabled ? undefined : onFocus}
    ref={ref}
    disabled={disabled}
  >
    <span className="ais-datepicker-trigger__icon"><PiCalendarBlank /></span>
    <input
      type="text"
      className="ais-datepicker-trigger__field"
      value={value}
      onChange={disabled ? undefined : onChange}
      onClick={disabled ? undefined : onClick}
      onFocus={disabled ? undefined : onFocus}
      placeholder="DD/MM/YYYY / hh:mm"
      readOnly
      disabled={disabled}
    />
  </button>
));

const AiExecutionMode = ({
  selectedMode = "Immediately",
  scheduleDate = null,
  onChange,
  disabled = false,
}) => {
  const [selected, setSelected] = useState(selectedMode || "Immediately");
  const [scheduleDateState, setScheduleDateState] = useState(toDateValue(scheduleDate));

  useEffect(() => {
    setSelected(selectedMode || "Immediately");
    setScheduleDateState(toDateValue(scheduleDate));
  }, [selectedMode, scheduleDate]);

  const emitChange = (mode, date = scheduleDateState) => {
    if (!onChange) return;
    onChange({
      mode,
      scheduleDate: date,
      campaignType: mode === "Test" ? "test" : "live",
      scheduledAt: mode === "Schedule for later" ? date : new Date(),
    });
  };

  const handleModeChange = (opt) => {
    if (disabled) return;
    setSelected(opt);
    emitChange(opt, opt === "Schedule for later" ? scheduleDateState : null);
  };

  const handleScheduleDateChange = (date) => {
    if (disabled) return;
    setScheduleDateState(date);
    emitChange("Schedule for later", date);
  };

  return (
    <div className="ais-card">
      <p className="ais-title">Execution Mode:</p>
      <div className="ais-radio-row">
        {OPTIONS.map((opt) => (
          <label key={opt} className={`ais-radio-label${disabled ? " disabled" : ""}`}>
            <input
              type="radio"
              name="execution"
              value={opt}
              checked={selected === opt}
              onChange={() => handleModeChange(opt)}
              disabled={disabled}
            />
            {opt}
          </label>
        ))}
      </div>
      {selected === "Schedule for later" && (
        <div className="ais-picker-wrap">
          <DatePicker
            selected={scheduleDateState}
            onChange={handleScheduleDateChange}
            minDate={getMinDate()}
            showTimeInput
            timeInputLabel="Time"
            dateFormat="dd/MM/yyyy hh:mm aa"
            disabled={disabled}
            customInput={<DateInput disabled={disabled} />}
            popperPlacement="bottom-start"
          />
        </div>
      )}
    </div>
  );
};

export default AiExecutionMode;
